module.exports = __webpack_public_path__ + "img/OBUHaveOrder_02.2e0a446f.png";